import { AnimatePresence, motion } from 'framer-motion';
import {
  BsFillCameraVideoFill,
  BsFillCameraVideoOffFill,
  BsMicFill,
  BsMicMuteFill,
} from 'react-icons/bs';
import { ImPhoneHangUp } from 'react-icons/im';
import { LuScreenShare, LuScreenShareOff } from 'react-icons/lu';
import { useSessionContext } from '../../contexts/SessionProvider';
import { ParticipantData } from '../../types/session';
import SessionControllerButton from '../CommonComps/Buttons/SessionControllerButton';
import FeedbackModal from '../CommonComps/Modals/FeedbackModal';

const SessionController = ({
  localUser,
  remoteUser,
}: {
  localUser: ParticipantData;
  remoteUser: ParticipantData;
}) => {
  // integration of context hooks here
  const {
    toggleUserCameraHandler,
    toggleUserMicHandler,
    toggleScreenShareHandler,
    callHangUpHandler,
    localScreenStream,
    isCameraEnabled,
    isMicEnabled,
    showFeedbackModal,
  } = useSessionContext();

  // rendering session controller component here
  return (
    <>
      <motion.div
        initial={{ y: 200 }}
        animate={{ y: 0 }}
        transition={{ type: 'spring', stiffness: 100, delay: 1 }}
        className='absolute flex items-center justify-center w-full gap-5 bottom-5'
      >
        <SessionControllerButton
          title={isCameraEnabled ? 'Mute Video' : 'Share Video'}
          onClick={toggleUserCameraHandler}
          isEnabled={isCameraEnabled}
        >
          {isCameraEnabled ? (
            <BsFillCameraVideoFill className='size-6 md:size-7 xl:size-8' />
          ) : (
            <BsFillCameraVideoOffFill className='size-6 md:size-7 xl:size-8' />
          )}
        </SessionControllerButton>

        <SessionControllerButton
          title={isMicEnabled ? 'Mute Audio' : 'Share Audio'}
          onClick={toggleUserMicHandler}
          isEnabled={isMicEnabled}
        >
          {isMicEnabled ? (
            <BsMicFill className='size-6 md:size-7 xl:size-8' />
          ) : (
            <BsMicMuteFill className='size-6 md:size-7 xl:size-8' />
          )}
        </SessionControllerButton>

        <SessionControllerButton
          title={localScreenStream ? 'Stop Presenting' : 'Present Screen'}
          onClick={toggleScreenShareHandler}
          isEnabled={localScreenStream === null}
        >
          {localScreenStream ? (
            <LuScreenShareOff className='size-6 md:size-7 xl:size-8' />
          ) : (
            <LuScreenShare className='size-6 md:size-7 xl:size-8' />
          )}
        </SessionControllerButton>

        <SessionControllerButton
          title='Hang Up'
          onClick={callHangUpHandler}
          isEnabled={false}
        >
          <ImPhoneHangUp className='size-6 md:size-7 xl:size-8' />
        </SessionControllerButton>
      </motion.div>

      <AnimatePresence initial={false} mode='wait' onExitComplete={() => null}>
        {showFeedbackModal ? (
          <FeedbackModal localUser={localUser} remoteUser={remoteUser} />
        ) : null}
      </AnimatePresence>
    </>
  );
};

export default SessionController;
